import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_APPROVAL_SCOPE_ACTION_TYPE } from '../actions/approvalScope.actions';

const initialState = null;

const approvalScopeReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_APPROVAL_SCOPE_ACTION_TYPE.SET_APPROVAL_SCOPE:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default approvalScopeReducer;
